const ERROR_CODE_USER_REGISTERED = 410;
const ERROR_CODE_AUTH_FAILED = 401;
export { ERROR_CODE_USER_REGISTERED, ERROR_CODE_AUTH_FAILED };
